import { createAsyncThunk } from "@reduxjs/toolkit";
import type { AppDispatch, RootState } from "app/store";
import type { RejectedValue } from "shared/interfaces/core-interfaces";

// createAsyncThunk with the app's state, dispatch and reject types filled in. Action types must
// still start with "Slice/": the token refresh middleware only reacts to those.
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
    state: RootState;
    dispatch: AppDispatch;
    rejectValue: RejectedValue;
}>();
